<script lang="ts">
	import Radio from "../components/Radio.svelte";
	import Step from "../components/wizard/Step.svelte";
	import {Utils} from '../util';
	import type {ReportType} from "../model";
	import {rt} from "../model";
	import NextButton from "../components/NextButton.svelte";
	import TwoCols from "../components/TwoCols.svelte";
	import ErrorBox from "../components/ErrorBox.svelte";
	import { _ } from '../services/i18n';

	declare var lang: string;

	export let currentStep: number;
	$:{
		if(currentStep == 1){

			console.log("set focus for 1")
		}
	}


	export let typeID = null;
	export let reportTypes: Promise<ReportType[]>;

	$: isValid = typeID != null;

	export function validate() {
		showError = true;
		return typeID != null;
	}

	const order = [3, 1, 2];

	$:sortedReportTypes = reportTypes?.then(rt => {
		let sorted = order.map(id => rt.find(r => r.id === id));
		sorted = sorted.concat(rt.filter(r => order.indexOf(r.id) < 0));
		return sorted;
	});


	let showError = false;



</script>

<Step let:current let:nextStep num={1} {validate}>
	<TwoCols rightStyle="display: flex; flex-direction: column">
		<svelte:fragment slot="left">
			<h1 class="main-heading">{$_('stepType.title')}</h1>
			{#await sortedReportTypes}
				{$_('types.loading')}
			{:then reportTypes}
				<ul class="type-container">
				{#each reportTypes as reportType, index}

					<li class="radio-container">
						<Radio bind:group={typeID} value="{rt(reportType).id}">
							{Utils.chooseTranslation(rt(reportType).name)}
						</Radio>
					</li>
				{/each}
				</ul>
			{:catch e}
				{$_('types.error')}
				{e}
			{/await}

			<ErrorBox show={showError && !isValid} msg="{$_('stepType.error')}"></ErrorBox>
		</svelte:fragment>
		<svelte:fragment slot="right">

			{#if lang === 'en'}
			<h2 class="red-title">Validate Report</h2>
			<p class="info-text">Using the form below, please reply to the various questions and give as much information as possible on the illegal content you wish to report.</p>

			<h2 class="red-title">Your Data</h2>
			<p class="info-text">
				The collected information is stored by the National Youth Service (hereinafter "NYS") on an electronic
				file and is exclusively used for processing your request via this form.
				This information will only be collected if you give your <strong>explicit consent</strong> to the NYS and KJT.</p>
			<p class="info-text">Your <strong>personal data</strong> will be kept for the entire duration of the management and will exclusively be used by the NYS.</p>
			{/if}
			{#if lang === 'de'}
				<h2 class="red-title">Meldung bestätigen</h2>
				<p class="info-text">Beim Beantworten der Fragen des nachstehenden Formulars, bitten wir Sie so viele Informationen wie möglich über den illegalen Inhalt zu geben, den Sie melden möchten.</p>

				<h2 class="red-title">Ihre Daten</h2>
				<p class="info-text">
					Die gesammelten Informationen werden vom Service national de la jeunesse (nachstehend "SNJ") in einer
					elektronischen Datei gespeichert und ausschließlich zur Bearbeitung Ihrer Anfrage über dieses Formular verwendet.
					Diese Informationen werden nur erfasst, wenn Sie der SNJ und KJT Ihre <strong>ausdrückliche Zustimmung</strong> erteilen.
				</p>
				<p class="info-text">Ihre <strong>personenbezogenen Daten</strong> werden für die gesamte Dauer der Verwaltung aufbewahrt und ausschließlich vom SNJ verwendet.</p>
			{/if}
			{#if lang === 'fr'}
				<h2 class="red-title">Valider le signalement</h2>
				<p class="info-text">Veuillez fournir autant d’informations que possible sur le contenu illégal potentiel que vous souhaitez signaler dans le formulaire ci-dessous.</p>

				<h2 class="red-title">Vos données</h2>
				<p class="info-text">
					Les informations recueillies sont enregistrées par le Service national de la jeunesse (ci-après "SNJ") dans un fichier électronique et sont exclusivement utilisées pour le traitement de votre demande via ce formulaire.
					Ces informations ne seront collectées que si vous donnez votre <strong>consentement explicite</strong> au SNJ et au KJT.</p>
				<p class="info-text">Vos <strong>données personnelles</strong> seront conservées pendant toute la durée de la gestion et seront exclusivement utilisées par le SNJ.</p>
			{/if}

			<NextButton {nextStep}></NextButton>
		</svelte:fragment>
	</TwoCols>

</Step>

<style>

	.type-container{
		padding: 0;
		list-style-type: none;
	}
	.type-container li{
		list-style-type:none;
	}
	.main-heading {
        margin-bottom: 84px;
    }

    .radio-container {
        margin-bottom: 10px;
    }
</style>
